// apply my apiKey
const apiKey = "7PBLkW4iSPk0M_1ijSB0RxKSJhxBtVjp8Ghm39ZGRGCKs1npGkOamMyWMtasYKc_l97qgDvSFSbQUxuM7TqVHPDyvMB-o9HqUThd2gm6NlQ7fadlysZ5x-vpr1eSY3Yx";

const Yelp = {
  searchYelp(term, location, sortBy) {
    // Go to https://cors-anywhere.herokuapp.com to authorize use before it functions in a browser
    return fetch(`https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`, {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    }).then((response) => {
      return response.json();
    }).then((jsonResponse) => {
      if (jsonResponse.businesses) {
        return jsonResponse.businesses.map((business) => {
          return {
            id: business.id,
            imageSrc: business.image_url,
            name: business.name,
            address: business.location.address1,
            city: business.location.city,
            zipCode: business.location.zip_code,
            category: business.categories[0].title,
            rating: business.rating,
            reviewCount: business.review_count,
          };
        });
      }
    })
  }
};

export default Yelp;